module.exports = function getResource(label, vars = []) {
    let resources = {
        userLabelText: `Vous devez être membre ${vars[0]} pour profiter de ce produit.`,
        signIn: 'Ouvrir une session',
        or: 'ou',
        signUp: 'S’inscrire',
        learnMore: 'En savoir plus',
        download: 'Download',
        openApp: 'open the Sephora app to purchase'
    };
    return resources[label];
};
